if (!customElements.get('collection-description')) {
  customElements.define(
    'collection-description',
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        this.preview = this.querySelector('[data-collection-description-preview]');
        this.ellipsis = this.querySelector('[data-collection-description-ellipsis]');
        this.full = this.querySelector('[data-collection-description-full]');
        this.content = this.querySelector('[data-collection-description-content]');
        this.collapsedToggle = this.querySelector('[data-collection-description-toggle="collapsed"]');
        this.expandedToggle = this.querySelector('[data-collection-description-toggle="expanded"]');

        if (
          !this.preview ||
          !this.ellipsis ||
          !this.full ||
          !this.content ||
          !this.collapsedToggle ||
          !this.expandedToggle
        )
          return;

        const characterLimit = Number.parseInt(this.dataset.characterLimit, 10) || 141;
        const descriptionText = this.content.textContent.replace(/\s+/g, ' ').trim();

        if (descriptionText.length <= characterLimit) return;

        this.preview.textContent = this.truncateAtWholeWord(descriptionText, characterLimit);
        this.collapsedToggle.addEventListener('click', () => this.setExpanded(true));
        this.expandedToggle.addEventListener('click', () => this.setExpanded(false));
        this.setExpanded(false);
      }

      truncateAtWholeWord(text, characterLimit) {
        const truncatedText = text.slice(0, characterLimit + 1);
        const lastWhitespaceIndex = truncatedText.search(/\s+\S*$/);

        return lastWhitespaceIndex > 0
          ? truncatedText.slice(0, lastWhitespaceIndex).trimEnd()
          : text.slice(0, characterLimit).trimEnd();
      }

      setExpanded(isExpanded) {
        this.full.hidden = !isExpanded;
        this.preview.hidden = isExpanded;
        this.ellipsis.hidden = isExpanded;
        this.collapsedToggle.hidden = isExpanded;
        this.expandedToggle.hidden = !isExpanded;
        this.collapsedToggle.setAttribute('aria-expanded', String(isExpanded));
        this.expandedToggle.setAttribute('aria-expanded', String(isExpanded));
      }
    }
  );
}
